<template lang='pug'>
  r-table(
    no-data-text='Sin notas de debito.'
    no-remove
    param-search='number'
    ref='table'
    v-bind='tableProps'
    @detail='selected = $event.item.reset(); dialog = true;'
    )
    template( slot='items' )
      r-dialog(
        content-class='grey lighten-3'
        no-confirm
        title='Nota de credito de venta'
        v-model='dialog'
        )
        r-form(
          class='white'
          no-submit
          reset-text='cerrar'
          v-bind='formProps'
          v-model='selected'
          @reset='dialog = false'
          )
</template>

<script>
  //
  import { RBtnAction, RDialog, RForm, RTable } from '@/components/reusable_components/next'
  //
  import SlSaleDebitNoteHeaders from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteHeaders'
  import SlSaleDebitNoteFields from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteFields'
  import SlSaleDebitNoteFilters from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteFilters'
  import SlSaleDebitNoteService from '@/services/api/Sale/SlSaleDebitNote'
  //
  export default {
    components: {
      RBtnAction,
      RDialog,
      RForm,
      RTable,
    },
    computed: {
      branchOfficessProps() {
        return {
          noAsyncSearch: true, 
          paramFilter: { 
            sl_customer_id: this.$route.params.id 
          },
        }
      },
      formProps() {
        return {
          editable: false,
          fields: SlSaleDebitNoteFields
            .variant('update')
        }
      },
      tableProps() {
        return {
          filters: SlSaleDebitNoteFilters.prop('sl_customer_branch_offices_id', this.branchOfficessProps),
          headers: SlSaleDebitNoteHeaders.get('customer_detail'),
          service: SlSaleDebitNoteService.toCustomerDetail(),
          paramFilter: {
            sl_customer_id: this.$route.params.id,
          },
        }
      },
    },
    data() {
      return {
        dialog: false,
        recent: '',
        selected: null,
      }
    },
  }
</script>
